import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import { FiPlus } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";

const AddEdit = () => {
  const history = useNavigate();
  const { id } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [form, setform] = useState({ title: "", audio: "" })
  const formValidation = [
    { key: "title", required: true, message: "Audio title is required" },
    { key: "audio", required: true, message: "Audio is required" },
  ]

  useEffect(() => {
    if (id) {
      getAudioDetail()
    }
  }, [])

  const getAudioDetail = () => {
    loader(true)
    ApiClient.get(`audio/detail?id=${id}`).then((res) => {
      if (res.success) {
        setform({ title: res?.data?.title, audio: res?.data?.audio })
      }
      loader(false)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    let invalid = methodModel.getFormError(formValidation, form)
    if (invalid) return
    let method = "post"
    let url = "audio/add"
    let value = {
      ...form,
    }
    if (id) {
      method = "put"
      url = "audio/update"
      value = {
        ...form,
        id: id,
      }
    } else {
      delete value.id
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/audio`)
      }
      loader(false)
    })
  }

  // Function to upload audio files and set audio path in audio key of form state
  const audioUpload = (e) => {
    let files = e.target.files
    let file = files.item(0)
    loader(true)
    ApiClient.postFormData('upload/audio', { file: file }).then(res => {
      if (res.success) {
        setform({ ...form, audio: res?.fileName })
      }
      loader(false)
    })
  }

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="one-time-code">
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link to={`/audio`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Audio</h3>
              </div>
            </div>

            <h3 className="ViewUser mb-3"></h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className=" mb-3">
                <FormControl
                  type="text"
                  name="title"
                  label="Title"
                  placeholder="Title"
                  value={form.title}
                  onChange={(e) => setform({ ...form, title: e })}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="lablefontcls">Audio <span className="text-red-600"> *</span></label>
                {form?.audio ?
                  <div>
                    <span className="relative inline-block">
                      <audio controls src={methodModel.audio(form?.audio)} />
                      <IoCloseOutline className="absolute top-0 -right-5 pointer hover:text-red-600" onClick={e => setform({ ...form, audio: "" })} size={25} />
                    </span>
                  </div>
                  :
                  <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                    <FiPlus />
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      onChange={audioUpload}
                    />
                    Upload Audio
                  </label>
                }
                {submitted && !form?.audio && <div className="text-red-600">Audio is required</div>}
              </div>
            </div>

            <div className="text-right">
              <button type="submit" className="text-white bg-[#F58D18] bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEdit;
